import { render, staticRenderFns } from "./new_users_created.vue?vue&type=template&id=7d110452&scoped=true&"
import script from "./new_users_created.vue?vue&type=script&lang=js&"
export * from "./new_users_created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d110452",
  null
  
)

export default component.exports